<script setup lang="ts">

import {MedicineCabinetCategory} from "@/core/interfaces/medicine-cabinet/MedicineCabinet";
import {ref} from "vue";
import pharmacistLogo from '@/assets/icons/pharmacist.svg';
import {useToastStore} from "@/stores/toast.store";
import {medicineCabinetApi} from "@/container";
import BaseButton from "@/core/components/base/BaseButton.vue";

const {category} = defineProps<{ category: MedicineCabinetCategory }>();

const advice = ref<string>(category.advice?.content ?? "");
const loading = ref<boolean>(false);
const {showSuccess} = useToastStore();

/**
 * Update medicine cabinet category advice, of the current pharmacist.
 */
const updateAdvice = (): Promise<void> => {
    if (advice.value) {
        loading.value = true;
        const request = category.advice
            ? medicineCabinetApi().updateAdvice(category.id, advice.value)
            : medicineCabinetApi().createAdvice(category.id, advice.value);

        return request.then((response) => {
            advice.value = response.content;
            showSuccess({
                content: "Votre conseil a bien été enregistré."
            });
        })
            .finally(() => loading.value = false);
    }

    return Promise.resolve();
};
</script>

<template>
  <h3 class="pb-8">
    Votre conseil pharmacien
  </h3>
  <div
    class="relative w-full h-28 text-sm bg-white border-gray-100 rounded-md shadow-md"
    :style="{boxShadow: `0px 0px 1px 3px ${category.color}`}"
  >
    <div class="bg-white absolute -top-8 left-4 rounded-full p-2">
      <img
        :src="pharmacistLogo"
        class="h-12"
        alt="pharmacien"
      >
    </div>
    <div class="absolute -bottom-6 right-4 rounded-full p-2">
      <BaseButton
        primary
        :loading="loading"
        :disabled="(category?.advice?.content.localeCompare(advice) === 0)"
        @click="updateAdvice"
      >
        Enregistrer
      </BaseButton>
    </div>
    <textarea
      v-model="advice"
      class="flex w-full pt-8 h-28 focus:ring-0 resize-none border"
      placeholder="Cliquez pour ajouter votre conseil..."
    />
  </div>
</template>

<style scoped>

</style>